import { BillRepository } from "../../repositories/BillRepository";
import { BillOperationResult } from "../../entities/BillEntity";

/**
 * Mark Bill As Duplicate Use Case
 * Marks a bill as duplicate
 */
export class MarkBillAsDuplicateUseCase {
  constructor(private repository: BillRepository) {}

  async execute(billId: number): Promise<BillOperationResult> {
    // Validate bill ID
    // if (!billId || billId <= 0) {
    //   throw new Error("Valid bill ID is required");
    // }

    return await this.repository.markBillAsDuplicate(billId);
  }
}
